"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationTypes = exports.EnumTypes = exports.FieldNames = exports.HttpRequestError = exports.OAuthHelper = exports.FolderNames = exports.GlobalSettingsNames = exports.ApiMethods = exports.CommonDataConnection = exports.TokenizedServiceConnection = exports.ReturnCodes = exports.HttpMethod = void 0;
var Promise = require("es6-promise");
var ApiConnection_1 = require("./ApiConnection");
var HttpMethod_1 = require("./HttpMethod");
Object.defineProperty(exports, "HttpMethod", { enumerable: true, get: function () { return HttpMethod_1.HttpMethod; } });
var ReturnCodes_1 = require("./ReturnCodes");
Object.defineProperty(exports, "ReturnCodes", { enumerable: true, get: function () { return ReturnCodes_1.ReturnCodes; } });
var TokenizedServiceConnection_1 = require("./tokenizedServices/TokenizedServiceConnection");
Object.defineProperty(exports, "TokenizedServiceConnection", { enumerable: true, get: function () { return TokenizedServiceConnection_1.TokenizedServiceConnection; } });
var CommonDataConnection_1 = require("./tokenizedServices/CommonDataConnection");
Object.defineProperty(exports, "CommonDataConnection", { enumerable: true, get: function () { return CommonDataConnection_1.CommonDataConnection; } });
var ApiMethods_1 = require("./ApiMethods");
Object.defineProperty(exports, "ApiMethods", { enumerable: true, get: function () { return ApiMethods_1.ApiMethods; } });
var GlobalSettingsNames_1 = require("./constants/GlobalSettingsNames");
exports.GlobalSettingsNames = GlobalSettingsNames_1.default;
var FieldNames_1 = require("./constants/FieldNames");
exports.FieldNames = FieldNames_1.default;
var FolderNames_1 = require("./constants/FolderNames");
Object.defineProperty(exports, "FolderNames", { enumerable: true, get: function () { return FolderNames_1.FolderNames; } });
var OAuthHelper_1 = require("./helpers/OAuthHelper");
Object.defineProperty(exports, "OAuthHelper", { enumerable: true, get: function () { return OAuthHelper_1.OAuthHelper; } });
var HttpRequestError_1 = require("./exceptions/HttpRequestError");
Object.defineProperty(exports, "HttpRequestError", { enumerable: true, get: function () { return HttpRequestError_1.HttpRequestError; } });
var EnumTypes_1 = require("./constants/EnumTypes");
exports.EnumTypes = EnumTypes_1.default;
var RelationTypes_1 = require("./constants/RelationTypes");
exports.RelationTypes = RelationTypes_1.default;
Promise.polyfill();
exports.default = ApiConnection_1.ApiConnection;
__exportStar(require("./data/EWItem"), exports);
__exportStar(require("./data/IApiAdditionalField"), exports);
__exportStar(require("./data/IApiAvailableBundle"), exports);
__exportStar(require("./data/IApiAvailableVersionResponse"), exports);
__exportStar(require("./data/IApiCapacityAvailableBundle"), exports);
__exportStar(require("./data/IApiColumn"), exports);
__exportStar(require("./data/IApiColumnPermission"), exports);
__exportStar(require("./data/IApiDataResponse"), exports);
__exportStar(require("./data/IApiDatumResponse"), exports);
__exportStar(require("./data/IApiContact"), exports);
__exportStar(require("./data/IApiCompany"), exports);
__exportStar(require("./data/IApiEnumType"), exports);
__exportStar(require("./data/IApiEnumValue"), exports);
__exportStar(require("./data/IApiFeature"), exports);
__exportStar(require("./data/IApiGlobalSetting"), exports);
__exportStar(require("./data/IApiGroup"), exports);
__exportStar(require("./data/IApiItemBase"), exports);
__exportStar(require("./data/IApiItemUsageStatus"), exports);
__exportStar(require("./data/IApiLead"), exports);
__exportStar(require("./data/IApiLicense"), exports);
__exportStar(require("./data/IApiLicenseBundleBase"), exports);
__exportStar(require("./data/IApiLocalizedLicenseBundle"), exports);
__exportStar(require("./data/IApiModulePermission"), exports);
__exportStar(require("./data/IApiObjectType"), exports);
__exportStar(require("./data/IApiPasswordStrength"), exports);
__exportStar(require("./data/IApiResult"), exports);
__exportStar(require("./data/IApiSaveResponse"), exports);
__exportStar(require("./data/IApiUser"), exports);
__exportStar(require("./data/IApiUserSetting"), exports);
__exportStar(require("./data/IApiWorkflowModel"), exports);
__exportStar(require("./data/query/IApiQuery"), exports);
__exportStar(require("./data/query/IApiQueryFilters"), exports);
__exportStar(require("./interfaces/ITranslatableString"), exports);
